import React from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import bootsLogo from "../../assets/images/Logo-Boots-1.png";
import Image from "react-bootstrap/Image";
import facebookIcon from "../../assets/icons/facebook.png";
import twitterIcon from "../../assets/icons/twitter.png";
import instagramIcon from "../../assets/icons/instagram.png";
import linkedinIcon from "../../assets/icons/linkedin.png";
import { useMediaQuery } from "react-responsive";

const Footer = () => {
  const isMobile = useMediaQuery({ minWidth: 992 });
  return (
    <div className="footer-ui">
      <Container>
        <Row className="mx-0">
          <Col className="col-12 col-lg-6 col-md-6 p-0 align-self-center">
            <div className="d-flex flex-column justify-content-center p-0">
              <h4 className="ageo-medium fs-14 mb-0">
                CONCEPTA DIAGNOSTICS: A BOOTS UK COMPANY
              </h4>
            </div>
          </Col>
          <Col className="col-12 col-md-6 col-lg-6 p-0 flex-row-reverse">
            <div className="right-footer-icons">
              <Link
                to="https://www.instagram.com/bootsuk/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  src={instagramIcon}
                  width={28}
                  height={28}
                  alt="Instagram"
                />
              </Link>

              <Link
                to="https://www.facebook.com/BootsUK/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  src={facebookIcon}
                  width={28}
                  height={28}
                  alt="Facebook"
                />
              </Link>

              <Link
                to="https://x.com/BootsUK"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image src={twitterIcon} width={28} height={28} alt="Twitter" />
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;
